import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";

export const SignUpTitle: React.FC<{
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  isFairePay?: boolean;
}> = ({ title, subtitle, isFairePay }) => {
  return (
    <Column gap={12}>
      <Typography variant={isFairePay ? "pageHeaderSerifRegular" : "displaySSerifRegular"}>{title}</Typography>
      {subtitle ? <Typography>{subtitle}</Typography> : null}
    </Column>
  );
};
